import Link from 'next/link';
import { Product } from '@/types/api';

interface ProductCardProps {
  product: Product;
}

export default function ProductCard({ product }: ProductCardProps) {
  // 检查产品数据完整性
  if (!product.slug) {
    console.error('[ProductCard] 产品缺少slug:', {
      id: product.id,
      title: product.title,
      slug: product.slug,
    });
  }
  
  const primaryImage = product.images?.find(img => img.isPrimary) || product.images?.[0];
  
  // 构建图片URL
  let imageUrl = 'https://via.placeholder.com/400x300?text=Product+Image';
  if (primaryImage?.imageUrl) {
    const imagePath = primaryImage.imageUrl;
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
      imageUrl = imagePath;
    } else {
      const apiBaseUrl = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3000/api';
      const baseUrl = apiBaseUrl.replace('/api', '');
      const path = imagePath.startsWith('/') ? imagePath : '/' + imagePath;
      imageUrl = baseUrl + path;
    }
  }
  
  // 如果slug不存在，使用id作为fallback（不推荐，但可以防止404）
  const productSlug = product.slug || product.id;
  
  if (!product.slug) {
    console.warn('[ProductCard] 产品缺少slug，使用ID作为fallback:', {
      id: product.id,
      title: product.title,
      fallbackSlug: productSlug,
    });
  }
  
  return (
    <div className="uc_post_grid_style_one_item ue_post_grid_item ue-item">
      <Link href={`/products/${productSlug}`} className="uc_post_grid_style_one_image">
        <div 
          className="uc_post_image"
          style={{ 
            backgroundImage: `url(${imageUrl})`,
          }}
        >
          <div className="uc_post_image_overlay"></div>
        </div>
      </Link>
      
      <div className="uc_content">
        <div>
          <div className="uc_post_title">
            <Link href={`/products/${productSlug}`}>
              <div>{product.title}</div>
            </Link>
          </div>
          
          <div className="ue-meta-data">
            {product.category && (
              <span className="ue-grid-item-category">
                <Link href={`/products?category=${product.category.slug}`}>
                  {product.category.name}
                </Link>
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

